export const UNIFIED_APP_CAMPAIGN_WIZARD_ID = 'UNIFIED_APP_CAMPAIGN_WIZARD_ID';
export const UNIFIED_APP_EDIT_CAMPAIGN_SETTINGS_WIZARD_ID = 'UNIFIED_APP_EDIT_CAMPAIGN_SETTINGS_WIZARD_ID';
export const UNIFIED_APP_EDIT_ASSET_GROUP_SETTINGS_WIZARD_ID = 'UNIFIED_APP_EDIT_ASSET_GROUP_SETTINGS_WIZARD_ID';

export const STEP_PATHS = {
  ASSETS: 'ASSETS',
  TARGETING: 'TARGETING',
  CAMPAIGN_DETAILS: 'CAMPAIGN_DETAILS',
  CAMPAIGN_DETAILS_EDIT: 'CAMPAIGN_DETAILS_EDIT',
  ASSETS_GROUP_EDIT: 'ASSETS_GROUP_EDIT',
  BUDGET: 'BUDGET',
  SUMMARY: 'SUMMARY',
};
